import React, { useContext, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AppRouter from "./components/AppRouter";
import { Context } from "./index";
import { observer } from "mobx-react-lite";
import { check } from "./http/userApi";
import { LOGIN_ROUTE } from "./utils/constants";

const App = observer(() => {
  const { user } = useContext(Context);

  useEffect(() => {
    console.log(window.location.pathname);
    check()
      .then((data) => {
        user.setUser(true);
        user.setIsAuth(true);
      })
      .catch((error) => {
        if (window.location.pathname === LOGIN_ROUTE) return;
        window.location.href = LOGIN_ROUTE;
      });
    // .finally(() => setLoading(false));
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#141414",
        light: "#141414",
        dark: "#141414",
      },
      secondary: {
        main: "#ff6000",
        light: "#ff6000",
        dark: "#ff6000",
      },
      mode: "dark",
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  );
});

export default App;
